import React, { useState } from 'react';
import { Modal, Button, Spinner, Row, Col } from 'react-bootstrap';

function useModal() {
    const [show, setShow] = useState(false);

    const ModalComponent = ({ title, body, loader, action, hideButton=false }) => (
        loader 
            ? (
                <Modal size='sm' backdrop='static' show={show} onHide={() => setShow(false)} centered>
                    <Modal.Body className="text-center py-4">
                        <Spinner animation='border text-yellow'/>
                        <div className="subtitulo__principal">
                            Cargando
                        </div>
                    </Modal.Body>
                </Modal>
            ) : (
                <Modal show={show} onHide={() => {setShow(false);action && action()}} centered>
                    <Modal.Body className="text-center">
                        <Row className='mt-4'>
                            <Col className='subtitulo__importancia'>
                                {title}
                            </Col>
                        </Row>
                        <Row className='mb-4'>
                            <Col className='texto__light'>
                                {body}
                            </Col>
                        </Row>
                        {
                            !hideButton && (
                                <Row className='mb-4'>
                                    <Col className='col-auto mx-auto'>
                                        <Button bsPrefix="ButtonPrimary" onClick={() => setShow(false)}>
                                            Cerrar
                                        </Button>
                                    </Col>
                                </Row>
                            )
                        }
                    </Modal.Body>
                </Modal>
            )
    );

    return [ModalComponent, setShow];
}

export default useModal;
